export default __webpack_public_path__ + "static/media/notifications.69f0e4c8.svg";